module.exports = __webpack_public_path__ + "static/media/Protect_section.f65605da.jpg";